module.exports = __webpack_public_path__ + "img/about-ch4-sectors-social-participation.7bcc064a.png";